module.exports = __webpack_public_path__ + "static/media/k12_site_about.aea0a85f.jpg";